import axios from 'axios';
import GetEmissionCalculationFlightsRequest = App.Data.Request.GetEmissionCalculationFlightsRequest;
import GetEmissionCalculationFlightsResponse = App.Data.Response.GetEmissionCalculationFlightsResponse;

export const getEmissionCalculation = async (
	data: GetEmissionCalculationFlightsRequest,
): Promise<GetEmissionCalculationFlightsResponse> => {
	const response = await axios.post('/emissions-calculator/flights', data);
	return response.data;
};
